import { Link } from 'react-router-dom'

/**
 * 404 Not Found page
 * Branded error page with navigation options
 */
export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-500 via-orange-400 to-amber-500 flex items-center justify-center p-6">
      {/* Background decorations - no avatars, just abstract shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -right-32 w-96 h-96 bg-orange-300/30 rounded-full blur-3xl" />
        <div className="absolute -bottom-48 -left-48 w-[500px] h-[500px] bg-amber-300/20 rounded-full blur-3xl" />
        <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-white/10 rounded-full blur-2xl" />
      </div>

      {/* Content card */}
      <div className="relative z-10 max-w-md w-full bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl shadow-orange-900/20 p-8 text-center animate-fade-in">
        {/* Big 404 */}
        <h1 className="text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-500 mb-4">
          404
        </h1>

        {/* Message */}
        <h2 className="text-xl font-bold text-slate-900 mb-2">
          Page Not Found
        </h2>
        <p className="text-slate-500 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Actions */}
        <div className="space-y-3">
          <Link 
            to="/" 
            className="block w-full py-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white font-semibold rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all"
          >
            Go to Quapp Store
          </Link>
          <button
            onClick={() => window.history.back()}
            className="block w-full py-3 bg-slate-100 text-slate-700 font-medium rounded-xl hover:bg-slate-200 transition-colors"
          >
            Go Back
          </button>
        </div>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-slate-100">
          <div className="flex items-center justify-center gap-2 text-sm text-slate-400">
            <span>Powered by</span>
            <img src="/quapp.png" alt="Quapp" className="h-5 object-contain" />
          </div>
        </div>
      </div>
    </div>
  )
}
